import React, { Ref } from 'react';
import IconBase, { IconProps } from '../IconBase';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const IconHangerXLarge = (
  baseProps: IconProps,
  svgRef?: Ref<SVGSVGElement>,
) => (
  <IconBase {...baseProps}>
    {({
      title,
      titleId,
      ...props
    }: React.SVGProps<SVGSVGElement> & SVGRProps) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        color="currentColor"
        aria-hidden="true"
        ref={svgRef}
        aria-labelledby={titleId}
        {...props}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M27.9 20.7L43.6225 32.321C43.8599 32.4965 44 32.7742 44 33.0694C44 33.5833 43.5833 34 43.0694 34H2.92635C2.41474 34 2 33.5853 2 33.0737C2 32.7762 2.14284 32.4968 2.38398 32.3227L21.6 17.9C23.4222 16.584 27.2 13.7 27.2 10.82082C27.2 8.1 25.7604 6 23 6C20.6804 6 18.8 7.8804 18.8 10.2V10.9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </IconBase>
);
const IconHangerXLargeWithRef = React.forwardRef(IconHangerXLarge);

IconHangerXLargeWithRef.displayName = 'IconHangerXLarge';

export default IconHangerXLargeWithRef;
